import { Data } from '@telstra-connect/utils';
import { FeatureFlagsHelper } from '@telstra-connect/feature-flags';
import { IFeatureFlags, IDashboardFlags } from './common';
import flagsData from './flags';

let helper: FeatureFlagsHelper<typeof Data.platformAppName>;

export const loadDashboardFeatureFlags = (getFlagsConfigFromState?: () => IDashboardFlags) => {
    helper = new FeatureFlagsHelper(Data.platformAppName, getFlagsConfigFromState, flagsData);
};

export const getDashboardFlags: () => IFeatureFlags = () => helper && helper.getFlags();
